export enum ApiModes {
    MOCK = 'mock',
    SERVER = 'server'
  }